import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./input.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// <div className="h-30 flex justify-center border border-black mt-10">
//     <p className="text-4xl">Customized as per your Specification.</p>
// </div>
